module.exports = __webpack_public_path__ + "img/010-donation-3.2cf223e6.svg";